<lib-page-container title="Multi Campaign" [loading]="screen.isLoading()" [version]="appVersion.version"
  [apiVersion]="appVersion.apiVersion$ | async">
  <div lib-page-breadcrumbs>
    <lib-breadcrumbs></lib-breadcrumbs>
  </div>
  <div lib-page-actions>
    <lib-button [disabled]="screen.isLoading()"
      *appHasAnyPermission="[permissions.CAMPAIGNMANAGEMENT_WRITE, permissions.CAMPAIGN_UPDATE]"
      (buttonClick)="onSave()" icon="saeve" tooltip="Save">Save</lib-button>
  </div>
  <div lib-page-body>
    <div class="flex-row gap-16">
      <app-campaign-base-edit #campaignBase [campaign]="campaign" fxFlex="490px"></app-campaign-base-edit>
      <mat-card appearance="outlined" class="flex-1">
        <mat-card-content>
          <mat-tab-group class="tab-group">
            <mat-tab label="Scheme">
              @if (campaign && !campaign.strategy) {
                <lib-button icon="add" tooltip="Add first step" (buttonClick)="onAddFirstStep()">Add first step</lib-button>
              }
              @if (campaign) {
                <app-strategy [strategy]="campaign.strategy" [parent]="null"></app-strategy>
              }
            </mat-tab>
            <mat-tab label="Locations">
              <app-campaign-location-filters #campaignLocationFilters [campaignId]="campaignId"></app-campaign-location-filters>
            </mat-tab>
            <mat-tab label="Json">
              <pre>{{ campaign | json }}</pre>
            </mat-tab>
            @if (campaignId) {
              <mat-tab label="Media">
                <app-campaign-media #campaignMedia [campaignId]="campaignId"></app-campaign-media>
              </mat-tab>
            }
          </mat-tab-group>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</lib-page-container>
<app-strategy-edit-panel #editPanel (strategySaved)="onStrategySaved($event)" />